import UserdataApi from './userdata-api';

export default UserdataApi;
